import { render, staticRenderFns } from "./ReservationOrders.vue?vue&type=template&id=7e58b66c&scoped=true"
import script from "./ReservationOrders.vue?vue&type=script&lang=js"
export * from "./ReservationOrders.vue?vue&type=script&lang=js"
import style0 from "./ReservationOrders.vue?vue&type=style&index=0&id=7e58b66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e58b66c",
  null
  
)

export default component.exports